export const MESSAGE_VOLUME_COVERAGE_REQUEST = 'MESSAGE_VOLUME_COVERAGE_REQUEST';
export const MESSAGE_VOLUME_COVERAGE_SUCCESS = 'MESSAGE_VOLUME_COVERAGE_SUCCESS';
export const MESSAGE_VOLUME_COVERAGE_FAILURE = 'MESSAGE_VOLUME_COVERAGE_FAILURE';
